module.exports = __webpack_public_path__ + "img/download.4abee223.svg";